<template>
  <div id="courseContent">
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Course content')"></breadcrumbs>
         <div class="col-lg-6 col-5 text-right">
            <base-button
              @click="startLearning"
              v-if="!learningIsStarted && firstLessonId >= 0"
              type="success">
              {{ $t('Start learning') }}
            </base-button>
            <base-button
              v-else
              @click="continueLearning"
              type="success">
              {{ $t('Continue learning') }}
            </base-button>
        </div>
      </div>
    </base-header>
    <v-wait for="course content fetching">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <block-draggable-list
                el-type="block"
                read-only
                mode="student"
                :value="getContent.blocks"/>
            </div>
          </div>
        </div>
      </div>
    </v-wait>
  </div>
</template>

<script>
  import Breadcrumbs from "../../Layout/Breadcrumbs.vue";
  import Spinner from 'vue-spinner-component/src/Spinner.vue';
  import BlockDraggableList from "../../../components/Draggable/BlockDraggableList";
  import {createNamespacedHelpers} from 'vuex';
  import {LessonProgressMixin} from "../../../mixins/Lesson/LessonProgressMixin";

  const {mapGetters, mapActions} = createNamespacedHelpers('student/course');

  export default {
    name: "CourseContent",
    metaInfo() {
      return {
        title: "Course content",
        htmlAttrs: {
          lang: 'ru'
        }
      }
    },
    mixins: [
      LessonProgressMixin
    ],
    components: {
      BlockDraggableList,
      Breadcrumbs,
      Spinner
    },
    computed: {
      ...mapGetters({
        getContent: 'getCurrentCourseContent',
      }),
      nextLessonIsAble() {
        return this.getNextLessonId() !== -1
      },
      firstLessonId() {
        try {
          return this.getContent.blocks[0].lessons[0].id
        } catch (e) {
          console.error(e.message)
        }
      }
    },
    watch: {
      '$route': 'fetchData',
    },
    methods: {
      ...mapActions({
        loadContent: 'loadCourseContent',
      }),

      async fetchData() {
        this.$wait.start('course content fetching');
        await this.loadContent({urlParams: this.$route.params});
        await this.loadProgress({urlParams: this.$route.params});
        this.$wait.end('course content fetching');
      },

      async startLearning() {
        const lessonId = this.firstLessonId;
        await this.learnLesson(lessonId);
      },

      isEmptyList(list) {
        return Array.isArray(list) && list.length === 0;
      },
    },
  };

</script>
